import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    active: null,
    list: new Map({})
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'TESTBENCH__SET_PACK':
            return core.setPack(state, action.pack);
        case 'TESTBENCH__SET_PACKS_CONFIG':
            return core.setPacksConfig(state, action.packs);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/data/Packs/reducer.js